import { isAndroid, isIOS } from 'react-device-detect'

export { isAndroid, isIOS }

export const MOBILE_LAYOUT_MAX_WIDTH_PX = 768

export type LayoutOverride = 'desktop' | 'mobile' | null

export type MobileLayoutSignals = {
    layoutOverride?: LayoutOverride
    viewportWidth?: number
}

export function shouldUseMobileLayout({
    layoutOverride = null,
    viewportWidth,
}: MobileLayoutSignals): boolean {
    if (layoutOverride) return layoutOverride === 'mobile'

    const width = Number(viewportWidth)
    return Number.isFinite(width) && width > 0 && width <= MOBILE_LAYOUT_MAX_WIDTH_PX
}

function getLayoutOverride(): LayoutOverride {
    if (typeof window === 'undefined') return null

    try {
        const layout = new URLSearchParams(window.location.search).get('layout')
        return layout === 'desktop' || layout === 'mobile' ? layout : null
    } catch {
        return null
    }
}

export const isMobile = shouldUseMobileLayout({
    layoutOverride: getLayoutOverride(),
    viewportWidth: typeof window === 'undefined' ? undefined : window.innerWidth,
})
